'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'UIComponents/decorators/Loadable';
import { ErrorLoadingAsync } from 'collaboration-sidebar/components/LoadingAsyncComponents';
const AsyncCollaborationSidebarContainerWithoutSidebarSkeleton = Loadable({
  loader: () => import(
  /* webpackChunkName: "collaboration-sidebar" */
  './CollaborationSidebarContainer').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: ({
    retry
  }) => /*#__PURE__*/_jsx(ErrorLoadingAsync, {
    retry: retry
  })
});
export default AsyncCollaborationSidebarContainerWithoutSidebarSkeleton;